<div> {{ name }} </div>

@for (drug of prescription.drugs; track drug) {
  <div class="pt-2">
    <i> {{ drug.description }} </i><br />
    <small>NDC: {{ drug.ndc }}</small>
  </div>
}
